/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Single row of the "View history of group and setting changes" report, matching the columns known from the desktop admin tool.
 * @export
 * @interface HistoryEntry
 */
export interface HistoryEntry {
    /**
     * Moment the change was recorded, as an ISO-8601 timestamp with the time zone offset. Kept as a plain string so it is presented exactly as returned, without any client side time zone conversion.
     * @type {string}
     * @memberof HistoryEntry
     */
    dateTime: string;
    /**
     * Sabre id (PCC_EPR) of the admin who made the change.
     * @type {string}
     * @memberof HistoryEntry
     */
    editedById: string;
    /**
     * Name of the admin who made the change.
     * @type {string}
     * @memberof HistoryEntry
     */
    editedByName: string;
    /**
     * Operation type, e.g. CREATE, UPDATE, DELETE, ASSIGN, UNASSIGN.
     * @type {string}
     * @memberof HistoryEntry
     */
    changeType: string;
    /**
     * Name of the affected group.
     * @type {string}
     * @memberof HistoryEntry
     */
    groupName?: string;
    /**
     * Name of the agent assigned to or unassigned from the group.
     * @type {string}
     * @memberof HistoryEntry
     */
    agentName?: string;
    /**
     * Sabre id (PCC_EPR) of the affected agent.
     * @type {string}
     * @memberof HistoryEntry
     */
    agentId?: string;
    /**
     * Name of the affected product.
     * @type {string}
     * @memberof HistoryEntry
     */
    productName?: string;
    /**
     * New value of the changed product setting.
     * @type {string}
     * @memberof HistoryEntry
     */
    newSetting?: string;
}

/**
 * Check if a given object implements the HistoryEntry interface.
 */
export function instanceOfHistoryEntry(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "dateTime" in value;
    isInstance = isInstance && "editedById" in value;
    isInstance = isInstance && "editedByName" in value;
    isInstance = isInstance && "changeType" in value;

    return isInstance;
}

export function HistoryEntryFromJSON(json: any): HistoryEntry {
    return HistoryEntryFromJSONTyped(json, false);
}

export function HistoryEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): HistoryEntry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'dateTime': json['dateTime'],
        'editedById': json['editedById'],
        'editedByName': json['editedByName'],
        'changeType': json['changeType'],
        'groupName': !exists(json, 'groupName') ? undefined : json['groupName'],
        'agentName': !exists(json, 'agentName') ? undefined : json['agentName'],
        'agentId': !exists(json, 'agentId') ? undefined : json['agentId'],
        'productName': !exists(json, 'productName') ? undefined : json['productName'],
        'newSetting': !exists(json, 'newSetting') ? undefined : json['newSetting'],
    };
}

export function HistoryEntryToJSON(value?: HistoryEntry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'dateTime': value.dateTime,
        'editedById': value.editedById,
        'editedByName': value.editedByName,
        'changeType': value.changeType,
        'groupName': value.groupName,
        'agentName': value.agentName,
        'agentId': value.agentId,
        'productName': value.productName,
        'newSetting': value.newSetting,
    };
}

